var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetalCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 211,
    viewBox: "0 0 222 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215.163 141.928L115.067 201.864C111.814 203.818 106.519 203.818 103.241 201.864L2.49729 141.928C0.852442 140.95 0.0240175 139.664 0.0240175 138.377L0 145.094C0 146.381 0.816419 147.668 2.47327 148.645L103.217 208.581C106.495 210.536 111.79 210.536 115.043 208.581L215.139 148.645C216.76 147.68 217.564 146.406 217.564 145.144L217.588 138.427C217.588 139.701 216.772 140.963 215.163 141.928Z",
    fill: "url(#paint0_linear_4651_859)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M215.127 134.875C218.405 136.83 218.417 139.984 215.163 141.939L115.067 201.875C111.814 203.83 106.519 203.83 103.241 201.875L2.49721 141.939C-0.780479 139.984 -0.792484 136.83 2.4612 134.875L102.557 74.9393C105.811 72.9847 111.105 72.9847 114.383 74.9393L215.127 134.875Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M174.053 129.67L112.221 166.695C110.457 167.747 107.599 167.759 105.822 166.695L43.582 129.67C42.6935 129.138 42.2493 128.445 42.2493 127.752L42.2253 134.47C42.2253 135.162 42.6695 135.855 43.558 136.387L105.798 173.413C107.575 174.464 110.432 174.464 112.197 173.413L174.029 136.387C174.906 135.868 175.338 135.175 175.338 134.494L175.362 127.777C175.362 128.47 174.918 129.15 174.053 129.67Z",
    fill: "url(#paint1_linear_4651_859)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.029 125.859C175.806 126.91 175.806 128.618 174.054 129.669L112.222 166.695C110.457 167.746 107.599 167.758 105.822 166.695L43.5821 129.669C41.8052 128.618 41.8052 126.91 43.5821 125.846L105.414 88.8209C107.167 87.7694 110.024 87.7694 111.801 88.8209L174.041 125.846L174.029 125.859Z",
    fill: "#F5F5F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M163.788 129.518L163.308 129.234L111.429 160.297L111.91 160.581C112.378 160.866 112.378 161.311 111.91 161.595L109.833 162.845C109.364 163.129 108.608 163.129 108.14 162.845L106.051 161.595C105.582 161.311 105.582 160.866 106.051 160.581L106.531 160.297L54.2919 129.221L53.8116 129.506C53.3434 129.79 52.587 129.79 52.1187 129.506L50.0296 128.256C49.5614 127.972 49.5614 127.526 50.0296 127.242L52.1067 125.993C52.575 125.708 53.3314 125.708 53.7996 125.993L54.2799 126.277L106.159 95.2142L105.678 94.9297C105.21 94.6451 105.21 94.1998 105.678 93.9152L107.743 92.6782C108.212 92.3937 108.968 92.3937 109.448 92.6782L111.537 93.9276C112.006 94.2121 111.994 94.6575 111.537 94.942L111.069 95.2266L163.308 126.302L163.776 126.017C164.245 125.733 165.001 125.733 165.481 126.017L167.57 127.267C168.039 127.551 168.027 127.997 167.57 128.281L165.505 129.518C165.037 129.803 164.281 129.803 163.8 129.518H163.788ZM110.301 159.628L162.18 128.566L161.699 128.281C161.231 127.997 161.231 127.551 161.699 127.267L162.168 126.982L109.929 95.9069L109.46 96.1915C108.992 96.476 108.236 96.476 107.755 96.1915L107.275 95.9069L55.3964 126.97L55.8767 127.254C56.3449 127.539 56.3449 127.984 55.8767 128.269L55.3964 128.553L107.635 159.628L108.116 159.344C108.584 159.059 109.34 159.059 109.809 159.344L110.289 159.628",
    fill: "#233449"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140.34 127.069C140.989 127.453 141.001 128.084 140.352 128.455L110.061 146.59C109.424 146.974 108.38 146.974 107.731 146.59L77.2477 128.455C76.5993 128.071 76.5873 127.441 77.2357 127.069L107.527 108.934C108.164 108.55 109.208 108.55 109.856 108.934L140.34 127.069Z",
    fill: "#233449"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M152.634 126.686C153.631 127.28 153.643 128.257 152.634 128.851L110.757 153.927C109.748 154.533 108.127 154.533 107.119 153.927L64.9531 128.839C63.9566 128.245 63.9446 127.268 64.9531 126.674L106.831 101.599C107.839 100.992 109.46 100.992 110.469 101.599L152.634 126.686ZM110.06 146.603L140.352 128.468C140.988 128.084 140.988 127.466 140.34 127.082L109.856 108.947C109.208 108.563 108.163 108.563 107.527 108.947L77.2355 127.082C76.5991 127.466 76.5991 128.084 77.2475 128.468L107.731 146.603C108.38 146.987 109.424 146.987 110.06 146.603Z",
    fill: "url(#paint2_linear_4651_859)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M182.122 83.9566L182.11 86.5669L177.704 83.9443V81.334L182.122 83.9566Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M186.756 86.727V89.3249L185.052 88.3105L185.064 85.7126L186.756 86.727Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M196.649 98.9752L196.637 101.585L193.408 99.668L193.42 97.0577L196.649 98.9752Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M201.812 95.6718V98.282L195.977 94.8182L195.989 92.208L201.812 95.6718Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M201.8 102.042L201.788 104.653L199.135 103.069V100.459L201.8 102.042Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M202.712 92.0709C204.297 93.0111 205.594 95.312 205.582 97.1924L205.558 107.262C205.558 109.142 204.261 109.909 202.664 108.957L175.626 92.875C174.03 91.9224 172.745 89.6339 172.757 87.7535L172.781 77.6838C172.781 75.8034 174.078 75.0364 175.674 75.989L202.712 92.0709ZM201.812 98.281V95.6708L195.989 92.207V94.8172L201.812 98.281ZM182.11 86.5659V83.9557L177.704 81.3331V83.9433L182.11 86.5659ZM196.637 101.584V98.9738L193.42 97.0563V99.6665L196.637 101.584ZM201.788 104.652V102.042L199.135 100.458V103.068L201.788 104.652ZM186.756 89.3246V86.7144L185.063 85.7V88.3102L186.756 89.3246Z",
    fill: "#101111"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.78967 31.0317L77.5 128.504L108.121 147.58L140.5 128.504L221.5 31.0317L2.78967 31.0317Z",
    fill: "url(#paint3_linear_4651_859)",
    style: {
      mixBlendMode: "screen"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M168.43 0C173.396 1.82158e-05 177.424 4.02727 177.424 8.99414C177.424 13.9608 173.396 17.9873 168.43 17.9873C163.463 17.9873 159.436 13.9608 159.435 8.99414C159.435 4.02726 163.463 0 168.43 0ZM166.044 4.5L163.007 12.8711H164.556L165.094 11.3887H168.682L169.22 12.8711H170.768L167.724 4.5H166.044ZM171.951 4.5V12.8711H173.41V4.5H171.951ZM168.143 9.92969H165.626L166.882 6.47949L168.143 9.92969Z",
    fill: "url(#paint4_linear_4651_859)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M168.43 0C173.396 1.82158e-05 177.424 4.02727 177.424 8.99414C177.424 13.9608 173.396 17.9873 168.43 17.9873C163.463 17.9873 159.436 13.9608 159.435 8.99414C159.435 4.02726 163.463 0 168.43 0ZM166.044 4.5L163.007 12.8711H164.556L165.094 11.3887H168.682L169.22 12.8711H170.768L167.724 4.5H166.044ZM171.951 4.5V12.8711H173.41V4.5H171.951ZM168.143 9.92969H165.626L166.882 6.47949L168.143 9.92969Z",
    fill: "url(#paint5_linear_4651_859)",
    fillOpacity: 0.4
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M168.43 0C173.396 1.82158e-05 177.424 4.02727 177.424 8.99414C177.424 13.9608 173.396 17.9873 168.43 17.9873C163.463 17.9873 159.436 13.9608 159.435 8.99414C159.435 4.02726 163.463 0 168.43 0ZM166.044 4.5L163.007 12.8711H164.556L165.094 11.3887H168.682L169.22 12.8711H170.768L167.724 4.5H166.044ZM171.951 4.5V12.8711H173.41V4.5H171.951ZM168.143 9.92969H165.626L166.882 6.47949L168.143 9.92969Z",
    fill: "url(#paint6_linear_4651_859)",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4651_859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.5637 57.3208L44.8513 46.7042L50.1442 43.3174L63.5944 50.9467L76.6171 43.2498L81.9794 46.6356L63.5637 57.3208Z",
    fill: "#929498"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5637 57.3208L44.8513 46.7042L50.1442 43.3174L63.5944 50.9467L76.6171 43.2498L81.9794 46.6356L63.5637 57.3208Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.979 46.6371L82.155 53.5634L63.5605 64.557L63.5605 57.3179L81.979 46.6371Z",
    fill: "#929498"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.979 46.6371L82.155 53.5634L63.5605 64.557L63.5605 57.3179L81.979 46.6371Z",
    fill: "#333333",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8505 46.7043L44.6765 53.6611L63.5607 64.5577L63.5607 57.3185L44.8505 46.7043Z",
    fill: "#929498"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1665 36.4855L70.331 43.5822L75.6919 46.9679L75.6919 40.1218L70.1665 36.4855Z",
    fill: "#3877B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9222 38.4058L73.0982 45.332L63.5605 51.0152L63.5605 43.776L72.9222 38.4058Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9222 38.4058L73.0982 45.332L63.5605 51.0152L63.5605 43.776L72.9222 38.4058Z",
    fill: "#333333",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3231 36.59L57.3231 43.0147L51.4249 47L51.4249 40.3501L57.3231 36.59Z",
    fill: "#3877B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3231 36.59L57.3231 43.0147L51.4249 47L51.4249 40.3501L57.3231 36.59Z",
    fill: "#333333",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9621 38.4849L53.7861 45.4111L63.5608 51.0152L63.5608 43.776L53.9621 38.4849Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5326 40.067L63.642 40.0026V47.0826L63.5668 47.1266L51.4242 40.3268V47.0026L44.8412 43.2789L45.0365 29.2223L63.5326 40.067Z",
    fill: "#3877B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9781 43.1732L75.692 46.9701V40.1215L63.6422 47.0824V40.0033L81.9781 29.2152V43.1732Z",
    fill: "#3877B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9781 43.1732L75.692 46.9701V40.1215L63.6422 47.0824V40.0033L81.9781 29.2152V43.1732Z",
    fill: "#333333",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9813 29.2109L63.6425 40.2305V40.1719L63.5526 40.2246L45.0341 29.2197L51.3358 25.6113L63.6425 32.6953V32.6797L75.6962 25.5254L81.9813 29.2109Z",
    fill: "#3877B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9813 29.2109L63.6425 40.2305V40.1719L63.5526 40.2246L45.0341 29.2197L51.3358 25.6113L63.6425 32.6953V32.6797L75.6962 25.5254L81.9813 29.2109Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6558 14.8413L63.7504 22.1106L51.0735 29.3153L51.0478 21.8967L63.6558 14.8413Z",
    fill: "#929498"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6558 14.8413L63.7504 22.1106L51.0735 29.3153L51.0478 21.8967L63.6558 14.8413Z",
    fill: "#333333",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.98 18.6519L81.98 25.7547L75.9489 29.3807L75.9489 22.0301L81.98 18.6519Z",
    fill: "#929498"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.98 18.6519L81.98 25.7547L75.9489 29.3807L75.9489 22.0301L81.98 18.6519Z",
    fill: "#333333",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0199 18.4435L45.0272 25.7572L51.0791 29.3399L51.0485 21.8962L45.0199 18.4435Z",
    fill: "#929498"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6538 14.8587L63.7572 22.1101L75.951 29.3789L75.951 22.0312L63.6538 14.8587Z",
    fill: "#929498"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6539 7.72229L81.9791 18.6496L75.9469 22.0292L63.6539 14.8517L51.0484 21.8969L45.0196 18.443L63.6539 7.72229Z",
    fill: "#929498"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6539 7.72229L81.9791 18.6496L75.9469 22.0292L63.6539 14.8517L51.0484 21.8969L45.0196 18.443L63.6539 7.72229Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6528 14.8487L63.7517 22.1085L54.2978 27.4811L54.2978 20.0806L63.6528 14.8487Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6528 14.8487L63.7517 22.1085L54.2978 27.4811L54.2978 20.0806L63.6528 14.8487Z",
    fill: "#333333",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2972 20.0874L54.2973 27.4769L63.5608 32.7993L63.561 25.0967L54.2972 20.0874Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6534 14.849L63.7506 22.1069L72.6165 27.3976L72.4187 19.9657L63.6534 14.849Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4398 19.98L72.6158 27.393L63.5605 32.7995L63.5605 25.0736L72.4398 19.98Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4398 19.98L72.6158 27.393L63.5605 32.7995L63.5605 25.0736L72.4398 19.98Z",
    fill: "#333333",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7207 22.1269L63.7396 18.9485L57.8367 22.0092L63.563 25.1091L68.7207 22.1269Z",
    fill: "url(#paint7_linear_4651_859)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4651_859)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.9115,
    cy: 17.5252,
    rx: 0.432877,
    ry: 0.433083,
    fill: "url(#paint8_linear_4651_859)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_4651_859)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.0096,
    cy: 18.0852,
    rx: 0.692603,
    ry: 0.692932,
    fill: "url(#paint9_linear_4651_859)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_4651_859)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.4272,
    cy: 22.1265,
    rx: 0.519452,
    ry: 0.519699,
    fill: "url(#paint10_linear_4651_859)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_4651_859)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.3373,
    cy: 23.5123,
    rx: 0.519452,
    ry: 0.519699,
    fill: "url(#paint11_linear_4651_859)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_4651_859)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.843,
    cy: 29.0913,
    rx: 0.432877,
    ry: 0.433083,
    fill: "url(#paint12_linear_4651_859)"
  })))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1314 30.5166L95.2084 12.6193H98.6379L102.744 26.3325L106.825 12.6193H110.231L112.332 30.5166H108.878L107.332 17.3355L107.888 17.3839L104.386 30.5166H101.029L97.4786 17.3839L98.0824 17.3597L96.585 30.5166H93.1314Z",
    fill: "#0D0D0D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M114.815 20.0685C114.815 19.2623 114.984 18.6335 115.322 18.182C115.676 17.7305 116.127 17.4161 116.674 17.2388C117.222 17.0614 117.753 16.9727 118.268 16.9727C118.848 16.9727 119.395 16.9808 119.911 16.9969C120.442 16.9969 120.933 17.005 121.384 17.0211C121.835 17.0372 122.253 17.0614 122.64 17.0937C123.042 17.1098 123.396 17.134 123.702 17.1662C124.024 17.1823 124.306 17.2065 124.548 17.2388V19.7541H119.307C118.953 19.7541 118.679 19.8347 118.486 19.9959C118.309 20.141 118.22 20.3668 118.22 20.6731V22.3903L123.606 22.5596V24.954L118.22 25.1474V26.7679C118.22 27.0259 118.26 27.2355 118.341 27.3967C118.437 27.5418 118.558 27.6466 118.703 27.7111C118.848 27.7756 119.009 27.8079 119.186 27.8079H124.548V30.3232C124.242 30.3554 123.896 30.3876 123.509 30.4199C123.123 30.4521 122.704 30.4844 122.253 30.5166C121.819 30.5328 121.376 30.5489 120.925 30.565C120.474 30.5811 120.039 30.5892 119.621 30.5892C119.202 30.6053 118.816 30.6134 118.462 30.6134C118.156 30.6134 117.793 30.5811 117.375 30.5166C116.956 30.4683 116.554 30.3554 116.167 30.178C115.781 29.9846 115.459 29.6863 115.201 29.2832C114.944 28.8801 114.815 28.3399 114.815 27.6627V20.0685Z",
    fill: "#0D0D0D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M126.187 16.9727H137.055V19.8508H133.312V30.5166H129.906V19.8508H126.187V16.9727Z",
    fill: "#0D0D0D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M151.537 16.9727H154.942V26.5744C154.942 26.8162 154.982 27.0178 155.063 27.179C155.143 27.3403 155.264 27.4612 155.425 27.5418C155.602 27.6063 155.812 27.6386 156.053 27.6386H160.376V30.5166H154.966C154.177 30.5166 153.525 30.4038 153.01 30.178C152.511 29.9523 152.141 29.6056 151.899 29.1381C151.658 28.6544 151.537 28.0336 151.537 27.2758V16.9727Z",
    fill: "#0D0D0D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M100.656 58.3727C99.6094 58.3727 98.6836 58.2518 97.8786 58.0099C97.0896 57.768 96.4134 57.3246 95.8498 56.6797C95.3024 56.0347 94.8838 55.1157 94.594 53.9225C94.3203 52.7133 94.1834 51.1493 94.1834 49.2305C94.1834 47.3763 94.3283 45.8607 94.6181 44.6837C94.924 43.4905 95.3588 42.5714 95.9223 41.9265C96.4858 41.2654 97.1701 40.8059 97.9752 40.5479C98.7802 40.2899 99.6899 40.1609 100.704 40.1609C101.509 40.1609 102.258 40.2093 102.95 40.3061C103.659 40.3867 104.295 40.4915 104.858 40.6205C105.422 40.7333 105.897 40.8623 106.283 41.0074V43.7888C105.993 43.7243 105.599 43.6598 105.1 43.5953C104.617 43.5308 104.061 43.4824 103.433 43.4502C102.805 43.4018 102.145 43.3776 101.453 43.3776C100.777 43.3776 100.197 43.4582 99.7141 43.6195C99.2471 43.7646 98.8688 44.0468 98.5789 44.466C98.3052 44.8691 98.0959 45.4576 97.951 46.2315C97.8222 47.0055 97.7578 48.0132 97.7578 49.2547C97.7578 50.4479 97.8142 51.4314 97.9269 52.2054C98.0557 52.9793 98.2569 53.5839 98.5306 54.0193C98.8044 54.4385 99.1747 54.7368 99.6416 54.9141C100.125 55.0754 100.728 55.156 101.453 55.156C102.677 55.156 103.667 55.1318 104.424 55.0834C105.196 55.0351 105.816 54.9786 106.283 54.9141V57.6713C105.848 57.8164 105.349 57.9454 104.786 58.0583C104.222 58.155 103.602 58.2276 102.926 58.2759C102.25 58.3404 101.493 58.3727 100.656 58.3727Z",
    fill: "#0D0D0D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M108.673 44.6837H112.078V54.2853C112.078 54.5272 112.118 54.7287 112.199 54.89C112.279 55.0512 112.4 55.1721 112.561 55.2527C112.738 55.3172 112.947 55.3495 113.189 55.3495H117.512V58.2276H112.102C111.313 58.2276 110.661 58.1147 110.146 57.889C109.647 57.6632 109.276 57.3166 109.035 56.849C108.793 56.3653 108.673 55.7445 108.673 54.9867V44.6837Z",
    fill: "#0D0D0D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M122.541 51.4556C122.541 52.2779 122.582 52.9551 122.662 53.4872C122.743 54.0032 122.879 54.4062 123.073 54.6965C123.266 54.9867 123.532 55.1882 123.87 55.3011C124.208 55.3979 124.642 55.4462 125.174 55.4462C125.689 55.4462 126.116 55.3979 126.454 55.3011C126.808 55.1882 127.082 54.9867 127.275 54.6965C127.468 54.4062 127.605 54.0032 127.686 53.4872C127.766 52.9551 127.806 52.2779 127.806 51.4556C127.806 50.6011 127.766 49.9158 127.686 49.3998C127.605 48.8678 127.468 48.4647 127.275 48.1906C127.082 47.9003 126.808 47.7068 126.454 47.6101C126.116 47.4972 125.689 47.4408 125.174 47.4408C124.659 47.4408 124.232 47.4972 123.894 47.6101C123.556 47.7068 123.282 47.9003 123.073 48.1906C122.879 48.4647 122.743 48.8678 122.662 49.3998C122.582 49.9158 122.541 50.6011 122.541 51.4556ZM119.136 51.4556C119.136 50.0206 119.265 48.8516 119.522 47.9487C119.78 47.0296 120.158 46.3283 120.658 45.8446C121.173 45.3447 121.801 45.0061 122.541 44.8288C123.298 44.6514 124.176 44.5627 125.174 44.5627C126.188 44.5627 127.066 44.6514 127.806 44.8288C128.563 45.0061 129.191 45.3447 129.69 45.8446C130.205 46.3283 130.584 47.0296 130.825 47.9487C131.083 48.8516 131.212 50.0206 131.212 51.4556C131.212 52.9067 131.083 54.0838 130.825 54.9867C130.584 55.8896 130.205 56.5829 129.69 57.0667C129.175 57.5504 128.539 57.889 127.782 58.0825C127.042 58.2598 126.172 58.3485 125.174 58.3485C124.176 58.3485 123.298 58.2598 122.541 58.0825C121.785 57.889 121.149 57.5504 120.633 57.0667C120.134 56.5829 119.756 55.8896 119.498 54.9867C119.257 54.0838 119.136 52.9067 119.136 51.4556Z",
    fill: "#0D0D0D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M133.503 44.6837H136.909V53.7774C136.909 54.1644 136.997 54.4788 137.174 54.7207C137.351 54.9625 137.617 55.1479 137.971 55.2769C138.326 55.3898 138.744 55.4462 139.227 55.4462C139.71 55.4462 140.121 55.3898 140.459 55.2769C140.813 55.1479 141.079 54.9625 141.256 54.7207C141.449 54.4788 141.546 54.1644 141.546 53.7774V44.6837H144.951V53.8016C144.951 54.7368 144.798 55.5027 144.492 56.0992C144.202 56.6797 143.8 57.1312 143.285 57.4536C142.769 57.7761 142.166 58.0018 141.473 58.1308C140.781 58.2598 140.032 58.3243 139.227 58.3243C138.438 58.3243 137.698 58.2598 137.005 58.1308C136.313 58.0018 135.701 57.7761 135.17 57.4536C134.638 57.1312 134.228 56.6797 133.938 56.0992C133.648 55.5027 133.503 54.7368 133.503 53.8016V44.6837Z",
    fill: "#0D0D0D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M153.481 55.3495C154.012 55.3495 154.423 55.2124 154.712 54.9383C155.018 54.6481 155.236 54.2208 155.364 53.6565C155.493 53.076 155.558 52.3424 155.558 51.4556C155.558 50.3431 155.477 49.5127 155.316 48.9645C155.155 48.4002 154.914 48.0293 154.592 47.852C154.286 47.6585 153.915 47.5617 153.481 47.5617H151.017V55.3495H153.481ZM147.612 44.6837H153.843C154.857 44.6837 155.694 44.8529 156.355 45.1915C157.015 45.5301 157.53 46.0058 157.9 46.6185C158.287 47.2312 158.56 47.9487 158.721 48.771C158.882 49.5933 158.963 50.4882 158.963 51.4556C158.963 53.0196 158.77 54.3014 158.383 55.3011C158.013 56.3008 157.449 57.0425 156.693 57.5262C155.936 57.9938 154.986 58.2276 153.843 58.2276H147.612V44.6837Z",
    fill: "#0D0D0D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M148.797 29.2277H137.813L143.305 19.0792L148.797 29.2277Z",
    stroke: "url(#paint13_linear_4651_859)",
    strokeWidth: 3.01287
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4651_859",
    x: 55.6145,
    y: 16.228,
    width: 2.59402,
    height: 2.59438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.432058,
    result: "effect1_foregroundBlur_4651_859"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4651_859",
    x: 64.4528,
    y: 16.5282,
    width: 3.11343,
    height: 3.1141,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.432058,
    result: "effect1_foregroundBlur_4651_859"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_4651_859",
    x: 72.0437,
    y: 20.7427,
    width: 2.76711,
    height: 2.76766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.432058,
    result: "effect1_foregroundBlur_4651_859"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_4651_859",
    x: 53.9538,
    y: 22.1284,
    width: 2.76711,
    height: 2.76766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.432058,
    result: "effect1_foregroundBlur_4651_859"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_4651_859",
    x: 68.546,
    y: 27.7941,
    width: 2.59402,
    height: 2.59438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.432058,
    result: "effect1_foregroundBlur_4651_859"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4651_859",
    x1: 0,
    y1: 174.215,
    x2: 217.588,
    y2: 174.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#768AAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7C90B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#97A9C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ACBDD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#BACBDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#C3D3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6D6E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4651_859",
    x1: 42.2253,
    y1: 150.985,
    x2: 175.374,
    y2: 150.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#768AAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7C90B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#97A9C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ACBDD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#BACBDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#C3D3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6D6E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4651_859",
    x1: 75.2184,
    y1: 108.934,
    x2: 137.469,
    y2: 141.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6092C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#3877B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275381"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4651_859",
    x1: 105.231,
    y1: 50.2334,
    x2: 104.33,
    y2: 145.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862475,
    stopColor: "#FFA200",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA200",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4651_859",
    x1: 162.431,
    y1: 2.71487,
    x2: 174.665,
    y2: 15.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#3877B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EC9E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE5131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4651_859",
    x1: 166.038,
    y1: 9.22972,
    x2: 174.298,
    y2: 7.69295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#3877B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EC9E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE5131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4651_859",
    x1: 168.43,
    y1: 7.84941e-8,
    x2: 167.113,
    y2: 11.8363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#3877B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#EC9E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE5131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4651_859",
    x1: 63.2787,
    y1: 18.9485,
    x2: 63.2787,
    y2: 25.1091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD4933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECA31D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4651_859",
    x1: 56.9115,
    y1: 17.0921,
    x2: 56.9115,
    y2: 17.9583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA31D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD4933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4651_859",
    x1: 66.0096,
    y1: 17.3923,
    x2: 66.0096,
    y2: 18.7781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA31D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD4933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4651_859",
    x1: 73.4272,
    y1: 21.6068,
    x2: 73.4272,
    y2: 22.6462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA31D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD4933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4651_859",
    x1: 55.3373,
    y1: 22.9926,
    x2: 55.3373,
    y2: 24.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA31D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD4933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4651_859",
    x1: 69.843,
    y1: 28.6582,
    x2: 69.843,
    y2: 29.5244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECA31D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD4933"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4651_859",
    x1: 143.305,
    y1: 15.9152,
    x2: 143.305,
    y2: 35.6743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE4C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECA11E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4651_859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.8405,
    height: 56.9855,
    fill: "white",
    transform: "translate(41.2869 7.72229)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetalCloud);
export default __webpack_public_path__ + "static/media/metal-cloud.df6916b89fdbada1da80514b37071f0e.svg";
export { ForwardRef as ReactComponent };